import { Text, textVariants } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';

const selfTransferListItemStyles = css`
  list-style: disc;
`;

const SelfTransferText = ({ text = '' }) => {
  const { t } = useTranslation();
  return (
    <li className={selfTransferListItemStyles}>
      <Text asHtml variant={textVariants._12}>
        {t(text)}
      </Text>
    </li>
  );
};

export default SelfTransferText;
